import approve from 'approvejs'
import { RESPONSIVE_BREAKPOINTS } from '../constants'

export function validateField (e, field, fields) {
  e.preventDefault()
  field.value = e.target.value

  const result = approve.value(e.target.value, field.rules)

  field.errors = []
  if (result.errors.length > 0) {
    field.errors = Array.from(result.errors)
  }

  return fields
}

export function submitForm (e, fields) {
  e.preventDefault()
  for (const key in fields) {
    fields[key].errors = []
    if (
      fields[key].options &&
      !fields[key].options.includes(fields[key].value)
    ) {
      fields[key].value = ''
    }
    const result = approve.value(fields[key].value, fields[key].rules)
    if (result.errors.length > 0) {
      fields[key].errors = Array.from(result.errors)
    }
  }

  return fields
}

export function initializeCustomValidators () {
  const phoneTest = {
    regex: /([\d +]\d)[\d #()-.]*$/,
    validate (value) {
      return this.regex.test(value)
    },
    expects: false,
    message: '{title} must be a valid phone number'
  }

  approve.addTest(phoneTest, 'phone')
}

export function getJwt () {
  const name = 'jwtToken='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')

  for (let c of ca) {
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }

  return ''
}

export const scrollElementIntoView = (elementId, navExpandBreakpoint, preventScrollDown = true, offset = 0) => {
  const element = document.getElementById(elementId)
  if (!element) {
    return
  }

  const navbarOffset = window.matchMedia(`(min-width: ${RESPONSIVE_BREAKPOINTS[navExpandBreakpoint]})`).matches ? 100 : 60
  const elementOffsetFromViewport = element.getBoundingClientRect().top
  if (!preventScrollDown || (elementOffsetFromViewport < navbarOffset)) {
    const y = elementOffsetFromViewport + window.pageYOffset + offset - navbarOffset
    window.scrollTo(0, y)
  }
}

export const isAssistantPathEnabled = () =>
    !!_enabledAssistantPaths[window.location.pathname] ||
    window.location.pathname.startsWith('/products')

const _enabledAssistantPaths = {
  '/': true,
  '/search': true,
  '/allergen': true,
  '/submit-inquiry': true,
  '/temperature-excursion-tool': true,
  '/about-us': true,
  '/find-my-msl': true,
  '/hcp-resources': true,
  '/congresses': true
}



// WEBPACK FOOTER //
// ./src/pages/functions.js